/**
 * Default values for site settings.
 * These constants ensure consistency across the application and tests.
 */

export const SITE_SETTINGS_DEFAULTS = {
  // Theme defaults
  primaryColor: '#0d6efd',
  fontFamily: '"Figtree", "Helvetica Neue", Helvetica, Arial, sans-serif',

  // Layout defaults
  hideNameInHeader: false,

  // Content defaults
  availablePostTypes: ['news', 'announcement', 'update'] as const,
  availableTopics: ['technology', 'business', 'general'] as const,
  generalInfo: '<p>General company information and helpful resources.</p>',

  // Access control defaults
  allowAllAnalystGroups: true,
  allowedAnalystGroupIds: [] as number[],
} as const;

export type SiteSettingsDefaults = typeof SITE_SETTINGS_DEFAULTS;
